export default "__VITE_ASSET__CmneHhgm__"